import React from 'react';
import MUISlider, {
  SliderProps as MUISliderProps,
} from '@material-ui/core/Slider';

interface SliderProps extends MUISliderProps {}

export default function Slider(props: SliderProps) {
  return <MUISlider {...props} />;
}
